module.exports = ":root{--lui-select-max-menuitems:var(--lui-menu-max-menuitems)}"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-select/theme/lui-select.global.scss
// module id = 308
// module chunks = 0 1 14